import { WindowScrollService } from './../../../core/services/window-scroll.service';
import { Column } from './../../table-models';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EnvironmentService } from './../../../core/enviroment/environment.service';

interface LeadByBroker {
  client: string;
  company: string;
  broker: string;
  product: string;
}

export interface Lead {
  queues: string;
  distributed: number;
  notAttended: number;
  notContacted: number;
  inAttendance: number;
  visit: number;
  proposal: number;
  sale: number;
  lista: LeadByBroker[];
}

@Component({
  selector: 'app-distribution-service',
  templateUrl: './distribution-service.component.html',
  styleUrls: ['./distribution-service.component.scss']
})
export class DistributionServiceComponent implements OnInit {

  public showFilter: boolean;
  public hasFilter: boolean;
  public selectedLeadsHeaders: Column[];
  public modal2: boolean;
  public titleLeadsModal: string;
  public textField = '';
  public dataSelected = [];
  public options = [];
  public data = [
    {
      queues: 'Produtos da região central de SP',
      distributed: 156,
      notAttended: 22,
      notContacted: 2,
      inAttendance: 30,
      visit: 10,
      proposal: 10,
      sale: 82,
      lista: [
        {
          client: 'Niels Henrick David Bohr',
          company: 'Lopes São Paulo',
          broker: 'Ribeiro (Martins)',
          product: 'Plano & Parque Do Carmo - Iososuke I'
        },
        {
          client: 'Charles Robert Darwin',
          company: 'Lopes São Paulo',
          broker: 'Alícia (Ferba)',
          product: 'Campanha Metas em M² - Alto Padrão'
        },
        {
          client: 'Stephen William Hawking',
          company: 'Lopes São Paulo',
          broker: 'Felix (Martins)',
          product: 'Absoluto Tatuapé'
        }
      ]
    },
    {
      queues: 'Empreendimentos de alto padrão',
      distributed: 145,
      notAttended: 0,
      notContacted: 14,
      inAttendance: 70,
      visit: 15,
      proposal: 10,
      sale: 18
    },
    {
      queues: 'Segmento econômico na Zona Leste',
      distributed: 267,
      notAttended: 11,
      notContacted: 11,
      inAttendance: 90,
      visit: 50,
      proposal: 15,
      sale: 90
    },
    {
      queues: 'Total',
      distributed: 486,
      notAttended: 33,
      notContacted: 27,
      inAttendance: 190,
      visit: 75,
      proposal: 53,
      sale: 190
    }
  ];

  public showDot: boolean;
  public form: FormGroup;
  public facId: string;
  public showFacModal: boolean;
  public headers = [
    { label: 'Filas', id: 'queues', sort: true, style: { width: '364px' } },
    {
      label: 'Distribuídos', id: 'distributed', sort: true, style: { width: '120px' }, dotted: true,
      onClick: (lead) => this.handleOpenLeads(lead)
    },
    {
      label: 'Não atendidos', id: 'notAttended', sort: true, style: { width: '120px' }, dotted: true,
      onClick: (lead) => this.handleOpenLeads(lead)
    },
    {
      label: 'Sem Contato', id: 'notContacted', sort: true, style: { width: '120px' }, dotted: true,
      onClick: (lead) => this.handleOpenLeads(lead)
    },
    {
      label: 'Em Atendimento', id: 'inAttendance', sort: true, style: { width: '125px' }, dotted: true,
      onClick: (lead) => this.handleOpenLeads(lead)
    },
    {
      label: 'Visita', id: 'visit', sort: true, style: { width: '100px' }, dotted: true,
      onClick: (lead) => this.handleOpenLeads(lead)
    },
    {
      label: 'Proposta', id: 'proposal', sort: true, style: { width: '100px' }, dotted: true,
      onClick: (lead) => this.handleOpenLeads(lead)
    },
    {
      label: 'Venda', id: 'sale', sort: true, style: { width: '100px' }, dotted: true,
      onClick: (lead) => this.handleOpenLeads(lead)
    },
  ];
  public listBinding = [];
  public finished = true;
  public featureInputSearch = false;

  get hasFinishedLoading(): boolean {
    return this.finished;
  }

  constructor(
    private fb: FormBuilder,
    private windowScroll: WindowScrollService,
    private environmentService: EnvironmentService,
  ) { }

  ngOnInit(): void {
    this.featureInputSearch = this.environmentService.getEnvVar('feature_input_search') === 'true';
    this.form = this.fb.group({
      dtCreateStart: null,
      dtCreateEnd: null,
      createHourStart: null,
      createHourEnd: null,
      dtDistributionStart: null,
      dtDistributionEnd: null,
      hourDistributionStart: null,
      hourDistributionEnd: null,
      distributionPending: false
    });
    this.modal2 = false;
    this.showFilter = false;
    this.hasFilter = false;
    this.selectedLeadsHeaders = [
      { label: 'Cliente', id: 'client', sort: true, avatar: true, style: { width: '190px' } },
      { label: 'Empresa', id: 'company', sort: true, style: { width: '130px' }, onClick: () => this.openFacModal() },
      { label: 'Corretor', id: 'broker', sort: true, style: { width: '120px' }, onClick: () => this.openFacModal() },
      { label: 'Produto', id: 'product', sort: true, style: { width: '300px' }, onClick: () => this.openFacModal() }
    ];
  }

  public clear() {
    this.hasFilter = false;
    this.form = this.fb.group({
      dtCreateStart: null,
      dtCreateEnd: null,
      createHourStart: null,
      createHourEnd: null,
      dtDistributionStart: null,
      dtDistributionEnd: null,
      hourDistributionStart: null,
      hourDistributionEnd: null,
      distributionPending: false
    });
  }

  public openFacModal() {
    // TODO: remove hard coded facID
    this.windowScroll.enable();
    this.facId = '01278d63-0000-0000-0000-000000000000';
    this.showFacModal = true;
  }

  public closeFacModal() {
    this.facId = null;
    this.showFacModal = false;
  }

  public applyFilter() {
    if (this.validator()) {
      this.hasFilter = true;
    }
    this.showFilter = false;
  }

  public closeLeadsByBroker() {
    this.modal2 = !this.modal2;
    this.titleLeadsModal = null;
    this.dataSelected = [];
    this.windowScroll.enable();
  }

  public handleModal() {
    this.showFilter = !this.showFilter;
  }

  public handleOpenLeads(lead: Lead) {
    if (!this.modal2) { this.windowScroll.disable(); }
    this.titleLeadsModal = lead.queues;
    this.dataSelected = lead.lista;
    this.modal2 = !this.modal2;
  }

  public validator(): boolean {
    if (Object.keys(this.form.controls).some(key => !!this.form.get(key).value)) {
      return true;
    }
    return false;
  }

  public disableInput(event) {
  }

  public elementSelected(event) {
  }

  public autocompleteSearch(value) {
  }

  public closedSearch() { }
  public searchInput(data) { }
  public searchElement(data) {
    this.options = [{ description: 'Produtos da região central de SP', type: 'Fila' }, { description: 'Empreendimentos de alto padrão', type: 'Fila' }, { description: 'Segmento econômico na Zona Leste', type: 'Fila' }];
  }

  public sort(event: MouseEvent, column: Column) {
    // TODO: sort by column
  }

}
